import React, { useState } from "react";
import { Button, Spinner } from "reactstrap";
import { startCheckout } from "../../services/subscriptionService";
import { getLoggedinUser } from "../../helpers/api_helper";

// Reusable "Subscribe" CTA. Creates a Stripe checkout session and redirects
// the browser to the hosted checkout ("pay first, then pick").
//
// Where it appears is decided by billing_mode, not by a flag anyone has to
// remember: on live keys the profile offers it to every member, on test keys
// only to an admin, because a test-mode checkout declines real cards and a
// visitor who reached it would hit a dead end.
const SubscribeButton = ({
  color = "primary",
  className = "",
  block = false,
  // Passed through so this can sit inline in a compact row -- the usage panel
  // puts it beside a line of text, where the default size dominates.
  size,
  label = "Unlock — $9.99/mo",
  children,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleClick = async () => {
    setError(null);

    // Anonymous visitors must create an account before they can subscribe.
    // Send them to login and bring them back to pick their symbol after.
    const user = getLoggedinUser();
    if (!user || !user.token) {
      // Signing in first, then back to whatever prompted the subscribe.
      window.location.href =
        `/login?redirect=${encodeURIComponent(window.location.pathname)}`;
      return;
    }

    setLoading(true);
    try {
      // Where they are now, so checkout returns them to it rather than to a
      // page they never asked for.
      const here = `${window.location.pathname}${window.location.search || ""}`;
      const res = await startCheckout(here);
      if (res && res.url) {
        window.location.href = res.url;
      } else {
        setError("Could not start checkout. Please try again.");
        setLoading(false);
      }
    } catch (e) {
      // 503 => billing not configured yet; 401 => not logged in. directApi
      // throws an Error, so the string test this used to do never matches now.
      setError(e?.message || "Checkout is unavailable right now.");
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        color={color}
        size={size}
        className={`${block ? "w-100" : ""} ${className}`}
        onClick={handleClick}
        disabled={loading}
      >
        {loading ? <Spinner size="sm" className="me-1" /> : null}
        {children || label}
      </Button>
      {error ? <div className="text-danger fs-12 mt-2">{error}</div> : null}
    </>
  );
};

export default SubscribeButton;
